import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Facet from './facet/facetContainer';
import AppliedFacets from './appliedFacets/appliedFacets';
import mediaQueries from '../../../utils/mediaQueries';
import { removeAllFacets as removeAllFacetsAction } from './facetsListActions';

class FacetsListMediumDown extends Component {
  constructor() {
    super();

    this.state = {
      isActive: false,
      displayStickyIndicator: false,
    };

    this.toggleRefineMenu = this.toggleRefineMenu.bind(this);
    this.sizeIndicatorDisplayCallback = this.sizeIndicatorDisplayCallback.bind(this);
  }

  toggleRefineMenu() {
    document.querySelector('html').classList.toggle('no-overlay-scroll');
    this.setState(({ isActive }) => ({ isActive: !isActive }));
  }

  sizeIndicatorDisplayCallback(value) {
    this.setState({ displayStickyIndicator: value });
  }

  render() {
    const { isActive, displayStickyIndicator } = this.state;
    const { facetIds, numberOfProducts, appliedItemsCount, removeAllFacets } = this.props;

    const refineButtonClass = [
      'button',
      'button--secondary',
      'expand',
      'product-list__product-filter-container--refine',
      'menu-btn',
      'menu-btn--open',
      'js-menu',
      isActive ? 'is-active' : '',
    ].join(' ');
    const applyButtonClass = ['button', 'apply-btn', isActive ? 'active' : ''].join(' ');

    if (facetIds.length === 0) {
      return null;
    }

    return (
      <div className="product-list__product-filter-container">
        <button
          type="button"
          className={refineButtonClass}
          onClick={this.toggleRefineMenu}
          aria-label={isActive ? 'close menu' : 'menu'}
        >
          {/* TODO replace with a FA icon */}
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 16.25C0 15.7422 0.390625 15.3125 0.9375 15.3125H3.24219C3.63281 14.0625 4.84375 13.125 6.25 13.125C7.61719 13.125 8.82812 14.0625 9.21875 15.3125H19.0625C19.5703 15.3125 20 15.7422 20 16.25C20 16.7969 19.5703 17.1875 19.0625 17.1875H9.21875C8.82812 18.4766 7.61719 19.375 6.25 19.375C4.84375 19.375 3.63281 18.4766 3.24219 17.1875H0.9375C0.390625 17.1875 0 16.7969 0 16.25ZM7.5 16.25C7.5 15.5859 6.91406 15 6.25 15C5.54688 15 5 15.5859 5 16.25C5 16.9531 5.54688 17.5 6.25 17.5C6.91406 17.5 7.5 16.9531 7.5 16.25ZM13.75 6.875C15.1172 6.875 16.3281 7.8125 16.7188 9.0625H19.0625C19.5703 9.0625 20 9.49219 20 10C20 10.5469 19.5703 10.9375 19.0625 10.9375H16.7188C16.3281 12.2266 15.1172 13.125 13.75 13.125C12.3438 13.125 11.1328 12.2266 10.7422 10.9375H0.9375C0.390625 10.9375 0 10.5469 0 10C0 9.49219 0.390625 9.0625 0.9375 9.0625H10.7422C11.1328 7.8125 12.3438 6.875 13.75 6.875ZM15 10C15 9.33594 14.4141 8.75 13.75 8.75C13.0469 8.75 12.5 9.33594 12.5 10C12.5 10.7031 13.0469 11.25 13.75 11.25C14.4141 11.25 15 10.7031 15 10ZM19.0625 2.8125C19.5703 2.8125 20 3.24219 20 3.75C20 4.29688 19.5703 4.6875 19.0625 4.6875H10.4688C10.0781 5.97656 8.86719 6.875 7.5 6.875C6.09375 6.875 4.88281 5.97656 4.49219 4.6875H0.9375C0.390625 4.6875 0 4.29688 0 3.75C0 3.24219 0.390625 2.8125 0.9375 2.8125H4.49219C4.88281 1.5625 6.09375 0.625 7.5 0.625C8.86719 0.625 10.0781 1.5625 10.4688 2.8125H19.0625ZM6.25 3.75C6.25 4.45312 6.79688 5 7.5 5C8.16406 5 8.75 4.45312 8.75 3.75C8.75 3.08594 8.16406 2.5 7.5 2.5C6.79688 2.5 6.25 3.08594 6.25 3.75Z"
              fill="#1F1F1F"
            />
          </svg>
          <FormattedMessage
            values={{ 0: appliedItemsCount }}
            id={`products.productgrid.${mediaQueries.is_small_only() ? 'filters' : 'filtersLarge'}`}
            description="Filter"
          />
        </button>
        {/* <FacetsBackdrop isActive={isActive} onClick={this.toggleRefineMenu} /> */}
        <div className="menu">
          <div
            className={`menu-sticky-size-indicator ${
              displayStickyIndicator ? 'animate-increase-height' : 'animate-decrease-height'
            }`}
          >
            <span>
              <FormattedMessage id="search.result.facet.size.indicator" description="Size indicator per locale" />
            </span>
          </div>
          <div className="menu-container-wrapper">
            <div className="menu-container">
              <AppliedFacets
                isMediumDown
                appliedItemsCount={appliedItemsCount}
                sizeIndicatorDisplayCallback={this.sizeIndicatorDisplayCallback}
                toggleRefineMenu={this.toggleRefineMenu}
              />
              <ul className="facet-list" data-accordion="facetAccordion">
                {facetIds.map((facetId, index) => (
                  <Facet
                    key={facetId}
                    facetId={facetId}
                    index={index}
                    isMediumDown
                    sizeIndicatorDisplayCallback={this.sizeIndicatorDisplayCallback}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
        {/* TODO to move this buttons below AppliedFacets without position fixed and unnecessary positioning */}
        {appliedItemsCount > 0 && (
          <div className={`${applyButtonClass} btn-container`}>
            <button type="button" className={applyButtonClass} onClick={this.toggleRefineMenu}>
              <FormattedMessage
                id="products.productgrid.apply"
                values={{ 0: numberOfProducts }}
                description="Show results"
              />
            </button>
            <button type="button" className={`${applyButtonClass} clear-filters`} onClick={removeAllFacets}>
              <FormattedMessage id="products.productgrid.clearFilters" />
            </button>
          </div>
        )}
      </div>
    );
  }
}

FacetsListMediumDown.propTypes = {
  numberOfProducts: PropTypes.number.isRequired,
  appliedItemsCount: PropTypes.number.isRequired,
  removeAllFacets: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  removeAllFacets: removeAllFacetsAction,
};

export default connect(null, mapDispatchToProps)(FacetsListMediumDown);
